import React from 'react';
import Moment from 'react-moment';

const dateToFormat = Date.now();

const Today = () => (
  <span className="position-absolute pos-top pos-right p-4">
    <Moment format="dddd, MMM DD, YYYY">{dateToFormat}</Moment>
  </span>
);

export default Today;
